import { connect } from 'react-redux';
import OnlineAuctionsDrawer from 'components/auctions/OnlineAuctionsDrawer';
import { showOnline } from 'data/app/App.actions';
import { createAuctionBids } from 'data/auctions/Auctions.actions';

const mapStateToProps = ({ app, auctions }) => ({
  creatingAuctionBidsFor: auctions.creatingAuctionBidsFor,
  fetchingOnlineAuctions: auctions.fetchingOnlineAuctions,
  membership:
    app.lookups && app.user
      ? app.lookups.memberships.find(m => m.ID === app.user.MembershipId)
      : null,
  onlineAuctions: auctions.onlineAuctions,
  partyId: app.user ? app.user.PartyId : null,
  partyType:
    app.user && app.lookups
      ? app.lookups.partyTypes.find(p => p.ID === app.user.PartyType)
      : null,
  merchantFees: app.merchantFees,
  membershipId: app.user ? app.user.MembershipId : null,
});

const mapDispatchToProps = dispatch => ({
  createBid: (auctionId, bidData, partyId) =>
    dispatch(createAuctionBids(auctionId, bidData, partyId)),
  onCloseDrawer: () => dispatch(showOnline(false)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnlineAuctionsDrawer);
